// import{useState} from 'react';
// import { useParams } from 'react-router-dom';
// import Menu from '../../components/Menu';
import Header from '../../../components/Header';
import MFooter from '../../../components/MFooter'
// import Loading from '../../../components/Loading'
import ALink from '../../../components/ALink'
// import {Error} from '../../../components/Erro'
// import useFind from '../../../hooks/useFind'
// import useForm from '../../../hooks/useForm'

// import './admmenu.css'
import {AdmMenuHome} from "./styled";

export default function Main(){
	//const params = useParams();
	// const [ocultarPopUp, setOcultarPopUp] = useState(false);
	return (
	  <>
	    {/* menu superior do dj*/}
	    <Header/>
	    {/*Conteudo*/}
		<AdmMenu/>
	    {/*Rodape*/}
	    <MFooter/>
	  </>
	);
};


function AdmMenu(){

	// const {data:adm_data, isLoading, error} =
	// 		useFind(`user/adm_links/`)
  //
	// if (error){
	// 	return (
	// 		<AdmMenuHome>
	// 			{!!error.messages
	// 				? <Error error={error.messages}/>
	// 				: <Error error={`${error}`}/>}
	// 		</AdmMenuHome>
	// 	)
	// }
	// if (isLoading){
	// 	return <AdmMenuHome style={{minHeight: "70vh"}}>
	// 		<LoadingV2/>
	// 	</AdmMenuHome>
	// }
  // if (!adm_data){
  //   return (
  //     <AdmMenuHome>
  //       <Error error={`Erro ao carregar`}/>
  //     </AdmMenuHome>
  //   )
  // }
	const icones = {
		"copy": "fi-rr-duplicate",
		"edit": "fi-rr-edit",
		"open": "fi-rr-browser",
		// "download": "fi-rr-cloud-download-alt",
		// "download": "fi-rr-folder-download",
		"download": "fi-rr-browser",
		"_": "fi-rr-edit"
	}
  const adm_data = {
    links:[
      {
				"icone":"copy",
				texto:"Copiar - Modelo BD Oficinas",
        to:"https://docs.google.com/spreadsheets/d/1epCsOc_PSRByLNX1x5ZTy9hj28nLfqN6gya293WxQU0/copy"
			},
      {
				"icone":"edit",
				texto:"Abrir - Planilha Municipios Acionados",
        to:"https://docs.google.com/spreadsheets/d/15fQ60v19vQgdoldVUPsIatW8j3QifBig6fa1pM4H-9Q/edit#gid=1719861861"
			},
      {
				"icone":"edit",
				texto:"Abrir - Link dos Grupos de Whatsapp",
        to:"https://docs.google.com/spreadsheets/d/15fQ60v19vQgdoldVUPsIatW8j3QifBig6fa1pM4H-9Q/edit#gid=2113095652"
			},
      {
				"icone":"edit",
				texto:"Abrir - BD - Kits - Torre",
        to:"https://docs.google.com/spreadsheets/d/15fQ60v19vQgdoldVUPsIatW8j3QifBig6fa1pM4H-9Q/edit#gid=1454043609"
			},
      {
				"icone":"edit",
				texto:"Abrir - BD - BD_Oficinas+GPzap",
        to:"https://docs.google.com/spreadsheets/d/15fQ60v19vQgdoldVUPsIatW8j3QifBig6fa1pM4H-9Q/edit#gid=1719861861"
			},
      {
				"icone":"edit",
				texto:"Abrir - BD - Kits - Básico",
        to:"https://docs.google.com/spreadsheets/d/15fQ60v19vQgdoldVUPsIatW8j3QifBig6fa1pM4H-9Q/edit#gid=304183908"
			},
      {
				"icone":"edit",
				texto:"Abrir - CONTATOS PONTO FOCAL",
        to:"https://docs.google.com/spreadsheets/d/15fQ60v19vQgdoldVUPsIatW8j3QifBig6fa1pM4H-9Q/edit#gid=1892142141"
			},
			{
				"icone":"edit",
				texto:"Abrir - Portifolio do MM (apresentação)",
        to:"https://docs.google.com/presentation/d/1Dn-YOVluU886zwYv-w3STHqeM2C3hlvApWPfYpb1Cl0/edit"
			},
			{
				"icone":"download",
				texto:"Baixar - Portifolio do MM (PDF)",
        to:"https://docs.google.com/presentation/d/1Dn-YOVluU886zwYv-w3STHqeM2C3hlvApWPfYpb1Cl0/export/pdf"
			},
    ]
  }
  const lista_links = adm_data.links.map(
    ({to,texto, icone}) => (<li>
      <i className={icones[icone]||icones["_"]}/>
			{"  "}
      <ALink href={to}>{texto}</ALink>
    </li>)
  )

  return (
		<AdmMenuHome>
      <div className="listagem">
				<h1>Atalhos</h1>
				<ul>
	        {lista_links}
	      </ul>
			</div>
		</AdmMenuHome>
	)
}


// para baixar um pdf de uma apresentação
// https://docs.google.com/presentation/d/e/2PACX-1vQjL1S0LN6sYyJWIzoVbPY1eMA844S1JVCXtsDB3StJMHcMNOc9l8ZqY1lGCWBuNuz1mgiIAbfkqr5d/pub?start=false&loop=false&delayms=3000
// https://docs.google.com/presentation/d/<FileID>/export/<format>
// https://docs.google.com/presentation/d/1Dn-YOVluU886zwYv-w3STHqeM2C3hlvApWPfYpb1Cl0/export/pdf
// https://docs.google.com/presentation/d/e/2PACX-1vQjL1S0LN6sYyJWIzoVbPY1eMA844S1JVCXtsDB3StJMHcMNOc9l8ZqY1lGCWBuNuz1mgiIAbfkqr5d/export/pdf
// https://docs.google.com/presentation/d/1Dn-YOVluU886zwYv-w3STHqeM2C3hlvApWPfYpb1Cl0/edit#slide=id.ge20d19bd99_0_0
